<template>
  <card-seplag titulo="Perfil usuários" class="card-seplag">
    <!-- <div class="p-grid p-fluid menu-container">
      <div class="menu-div p-col-12 p-md-2">
        <Button label="Adicionar empregado público" class="p-button-secondary p-button-rounded"
          @click="abrirBuscaEmpregado()" />
      </div>
      <div class="menu-div p-col-12 p-md-2">
        <Button label="Adicionar novo usuário" class="p-button-secondary p-button-rounded"
          @click="abrirBuscaUsuario()" />
      </div>
    </div> -->
    <div class="pesquisa-usuario-container p-col-12">
      <!-- {{usuarios.content[0].id}} -->
      <div class="p-grid p-fluid ">
        <Rotulo nome="Órgão/ Empresa pública" cols="12 4">
          <Dropdown class="classe-dropdown" key="orgaoEmpresaUsuario" v-model="filtro.orgaoEmpresaUsuario"
            :options="dropdownOrgao" showClear optionLabel="descricao" optionValue="idenOrgao"
            placeholder="Selecione um Órgao/Empresa Pública" :filter="true" />
        </Rotulo>
        <Rotulo nome="Perfil acesso" cols="12 3">
          <Dropdown class="classe-dropdown" key="idenPerfilAcesso" v-model="filtro.idenPerfilAcesso"
            :options="dropdownPerfilAcesso" showClear optionLabel="nomePerfilAcesso" optionValue="id"
            placeholder="Selecione um Perfil " />
        </Rotulo>

        <Rotulo nome="Pesquisa por nome/ CPF/ Matrícula" cols="12 3">
          <InputText type="text" key="textoPesquisa" v-model="filtro.textoPesquisa"
            @keyup.enter="pesquisarUsuarioPerfilOrgao()" style="text-transform: uppercase ;" />
        </Rotulo>
        <Rotulo cols="12 2">
          <Button class="classe-buttom" icon="pi pi-search" @click="pesquisarUsuarioPerfilOrgao()" label="Buscar" />
        </Rotulo>

      </div>
    </div>


    <table-seplag :dados.sync="usuarios.content" :totalRegistro.sync="usuarios.totalElements" :campos="camposTabela"
      :hasExibirCabecalho="usuarios.content.length > 0" :onEditarDado="abrirBuscaUsuario"
      :onSearchPaginacao="paginacaodabusca" :rows="10" :paginacao="true" :hasEventoAcao="true" cols="12"
      v-if="usuarios">
      <template #buttonsHeader v-if="usuarios.content.length > 0">
        <div style="display:flex">
          <Button label="Excel" icon="pi pi-external-link" class="p-button-raised"
            style="margin:5px;background:#107c41; border-color: rgb(1 114 52);" @click="exportExcel()" />
          <Button label="PDF" icon="pi pi-external-link" class="p-button-raised"
            style="margin:5px;background:#c5031d; border-color: #b70019;" @click="exportPDF()" />
        </div>
      </template>
    </table-seplag>

    <Dialog :visible.sync="exibirModalsuario" :contentStyle="'max-width:80rem; max-height:40rem; width:80rem;'"
      :modal="true" header="Cadastro">
      <div class="p-grid p-fluid" style="">
        <div class="p-col-4 p-md-4" v-if="!registro.id">
          <Button label="Cadastrar" class="p-button-info" icon="pi pi-check" @click="cadastrarUsuario()" />
        </div>
        <div class="p-col-4 p-md-4" v-if="registro.id">
          <Button label="Salvar" class="p-button-warning" icon="pi pi-user-edit" @click="atualizarUsuario()" />
        </div>
      </div>
    </Dialog>

    <ExibirPDF v-if="pdfBase64" v-model="exibirPDFDocumento" :tamanhoTela="'70.vw'" :alturaTela="'50.vw'"
      :tituloTela="nomeModalPDF" :pdfElement="pdfBase64" />


  </card-seplag>

</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import { baseApiUrl } from "@/config/global";
import TableSeplag from "@/template/TableSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import ExibirPDF from '@/template/CardExibirPDF.vue'
import download from 'downloadjs';
import moment from 'moment';



const getCadastroPessoa = () => {
  return {
    ativoConta: "S",
    nomeApresentacao: "",
    login: "",
    trocarSenha: 'S',
    id: 0,
    pessoa: {
      nomePessoa: "",
      numrCpf: "",
      dataNascimento: "",
      flagSexo: null,
      descEmail: "",
      numrTelefonePessoal: null,
      numrTelefoneComercial: null,
      numrTelefoneCelular: null,
      endrTipoLogradouro: "",
      endrLogradouro: "",
      endrBairro: "",
      endrComplemento: "",
      numrCep: "",
      endrNumero: "",
      cidadeEnd: null,
      ufRg: null,
      statPessoa: 1,
      flagOrigem: "RECADASTRAMENTO",
      flagServidor: "N",
      servidor: {
        numrMatricula: null
      },
      listaServidorOrgaoSetor: {
        numMatricula: null
      },
      escolaridade: {
        idenEscolaridade: 0
      }
    },
    perfis: [],
    numrMatricula: null,
    teste: null

  };
};

export default {
  name: "cadastroUsuario",
  components: { CardSeplag, TableSeplag, Rotulo, ExibirPDF },
  model: {
    prop: "exibirModalPerfil",
    event: "change",
  },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      ciclopessoa: this.$store.getters.getCicloPessoa,
      dropdownPerfilAcesso: null,
      dropdownOrgao: null,
      registro: getCadastroPessoa(),
      exibirModalsuario: false,
      messagemUsuario: false,
      loadingListUsuario: false,
      selectUsers: null,
      inputBusca: null,
      usuarios: null,
      usuariosBusca: null,
      nomeDialogo: null,
      sexo: false,
      dadosVinculoPessoa: [],
      camposTabela: [
        { titulo: "Nome", nome: "pessoa.nomePessoa" },
        { titulo: "CPF", nome: "pessoa.cpfFormatado" },
        { titulo: "E-mail", nome: "pessoa.descEmail" },
        { titulo: "Matricula", nome: "pessoa.servidor.numrMatricula" },
      ],
      filtro: {
        textoPesquisa: '',
        idenPerfilAcesso: null,
        idenPessoaUsuario: null,
        orgaoEmpresaUsuario: null,
      },
      filtroTodosOrgaos: {
        "idenOrgao": 0,
        "descOrgao": 'TODOS'
      },
      filtroTodosPerfis: {
        "idenOrgao": 0,
        "descOrgao": 'TODOS'
      },
      perfilSelecionado: null,
      autorizacaoSelecionada: [],
      contaacesso: null,
      totalregistro: null,
      elementofiltrado: null,
      cities: [],
      exibirPDFDocumento: null,
      pdfBase64: "",
      usuariosSelecionados: null,
      teste: []

    };
  },

  //  CONEXÃO COM A API

  methods: {
    carregarDados() {
      this.filtro.idenPessoaUsuario = this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa
      this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then(res1 => {
        this.dropdownOrgao = res1.data
      })
      this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/`).then(res2 => {
        this.dropdownPerfilAcesso = res2.data
      })
      let filtroPerfilUsuario = localStorage.getItem("filtroPerfilUsuario")
      if (filtroPerfilUsuario) {
        let filtroLocalStorage = JSON.parse(filtroPerfilUsuario)
        this.filtro = { ...filtroLocalStorage }
        this.usuarios = filtroLocalStorage.dados

      } else {
        let postBody = {
          listaOrgaos: null,
          listaPerfilAcesso: null,
          textoPesquisa: null,
          //usuarioLogado: this.ciclopessoa[0].vinculosAtivos[0].nomePessoa,
          usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa
        }

        this.$http.post(`${baseApiUrl}/seguranca/contasacesso/usuario?size=10&page=0`, JSON.stringify(postBody)).then(res4 => {
          this.usuarios = res4.data
        })
      }
    },
    paginacaodabusca(rows, page) {
      if (this.filtro.orgaoEmpresaUsuario == null && this.filtro.idenPerfilAcesso == null && this.filtro.textoPesquisa == '') {
        this.$http.get(`${baseApiUrl}/seguranca/contasacesso?size=${rows}&page=${page}`).then(res => {
          this.usuarios = res.data
        })
      } else {
        if (this.ciclopessoa) {
          let postBody = {
            listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
            listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
            textoPesquisa: this.filtro.textoPesquisa,
            //usuarioLogado: this.ciclopessoa[0].vinculosAtivos[0].nomePessoa,
            usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
          }
          this.$http.post(`${baseApiUrl}/seguranca/contasacesso/usuario?size=${rows}&page=${page}`, JSON.stringify(postBody)).then(res1 => {
            this.usuarios = res1.data
            this.totalregistro = this.usuarios.totalElements;
          })
        } else {
          let postBody = {
            listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
            listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
            textoPesquisa: this.filtro.textoPesquisa,
            usuarioLogado: ' ',
          }
          this.$http.post(`${baseApiUrl}/seguranca/contasacesso/usuario?size=${rows}&page=${page}`, JSON.stringify(postBody)).then(res1 => {
            this.usuarios = res1.data
            this.totalregistro = this.usuarios.totalElements;
          })
        }
      }
    },
    async abrirBuscaUsuario(dados = null) {

      if (dados) {
        this.registro = JSON.parse(JSON.stringify(dados))
        this.$http.get(`${baseApiUrl}/seguranca/contasacesso/${this.registro.id}/perfis `).then(res => {
          if (res.data.length > 0) {
            let perfisAcessoUsuario = []
            for (let i = 0; i < res.data.length; i++) {
              perfisAcessoUsuario.push({
                contaAcesso: this.registro.id,
                perfilAcesso: res.data[i]
              })
            }
            this.registro.perfis = perfisAcessoUsuario
          }
        });
          this.$router.push({ name: 'CADUSUARIO_NOVO_VIEW', params: { data: this.registro, empregadoPublico: false } })
      } else {
        this.registro = getCadastroPessoa();
        this.$router.push({ name: 'CADUSUARIO_NOVO_VIEW', params: { data: this.registro, empregadoPublico: false } })
      }
    },
    async abrirBuscaEmpregado() {
      this.registro = getCadastroPessoa();
      this.$router.push({ name: 'empregado-dados', params: { data: this.registro, empregadoPublico: true } })
    },
    pesquisarUsuarioPerfilOrgao() {
      let postBody = {
        listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
        listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
        textoPesquisa: this.filtro.textoPesquisa,
        //usuarioLogado: this.ciclopessoa[0].vinculosAtivos[0].nomePessoa,
        usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa
      }
      this.$http.post(`${baseApiUrl}/seguranca/contasacesso/usuario?size=10&page=0`, JSON.stringify(postBody)).then(res => {
        this.usuarios = res.data

        let props = {
          orgaoEmpresaUsuario: this.filtro.orgaoEmpresaUsuario,
          idenPerfilAcesso: this.filtro.idenPerfilAcesso,
          textoPesquisa: this.filtro.textoPesquisa,
          dados: res.data
        }

        localStorage.setItem('filtroPerfilUsuario', JSON.stringify(props))

        if (this.usuarios.content.length == 0) {
          this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Não Foi encontrado nem um usuário com essas informações', life: 5000 });
        }
      })



    },
    exportExcel() {
      if (this.ciclopessoa) {
        let bodyRelatorio = {
          listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
          listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
          textoPesquisa: this.filtro.textoPesquisa,
          //usuarioLogado: this.ciclopessoa[0].vinculosAtivos[0].nomePessoa,
          usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
          tipoRelatorioEnum: "EXCEL"
        }
        this.$http.post(`${baseApiUrl}/relatoriousuarios/buscausuario`, JSON.stringify(bodyRelatorio)).then(res => {
          download(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        })
      } else {
        let bodyRelatorio = {
          listaOrgaos: [this.filtro.orgaoEmpresaUsuario],
          listaPerfilAcesso: [this.filtro.idenPerfilAcesso],
          textoPesquisa: this.filtro.textoPesquisa,
          usuarioLogado: ' ',
          tipoRelatorioEnum: "EXCEL"
        }
        this.$http.post(`${baseApiUrl}/relatoriousuarios/buscausuario`, JSON.stringify(bodyRelatorio)).then(res => {
          download(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        })
      }
    },
    exportPDF() {
      if (this.ciclopessoa) {
        let bodyRelatorio = {
          listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
          listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
          textoPesquisa: this.filtro.textoPesquisa,
          //usuarioLogado: this.ciclopessoa[0].vinculosAtivos[0].nomePessoa,
          usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
          tipoRelatorioEnum: "PDF"
        }
        this.$http.post(`${baseApiUrl}/relatoriousuarios/buscausuario`, JSON.stringify(bodyRelatorio)).then(res => {
          if (res.data.dadosRelatorioBase64.length > 10000000) {

            download(`data:application/pdf;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/pdf");

          } else {
            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
            this.exibirPDFDocumento = true
            this.nomeModalPDF = 'RELATÓRIO DE USUÁRIOS - PDF'
          }
        })
      } else {
        let bodyRelatorio = {
          listaOrgaos: this.filtro.orgaoEmpresaUsuario ? [this.filtro.orgaoEmpresaUsuario] : null,
          listaPerfilAcesso: this.filtro.idenPerfilAcesso ? [this.filtro.idenPerfilAcesso] : null,
          textoPesquisa: this.filtro.textoPesquisa,
          usuarioLogado: ' ',
          tipoRelatorioEnum: "PDF"
        }
        this.$http.post(`${baseApiUrl}/relatoriousuarios/buscausuario`, JSON.stringify(bodyRelatorio)).then(res => {
          this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
          this.exibirPDFDocumento = true
          this.nomeModalPDF = 'RELATÓRIO DE USUÁRIOS - PDF'
          // download(`data:application/pdf;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/pdf");
        })
      }
    },

  },
  mounted() {
    this.carregarDados();
  },

  computed: {
    getCicloPessoa() {
      return this.$store.getters.getCicloPessoa
    }
  },
  watch: {
    getCicloPessoa(novoCicloPessoa) {
      this.ciclopessoa = novoCicloPessoa
      this.dataInicioClico = moment(this.ciclopessoa[0].ciclo.dataInicio, 'DD/MM/YYYY').locale('pt-br').format('LL')
      this.dataFimClico = moment(this.ciclopessoa[0].ciclo.dataFinal, 'DD/MM/YYYY').locale('pt-br').format('LL')

    }

  }
};
</script>

<style scoped>
.menu-container {
  width: 100%;
  text-align: left;
  margin-top: 0.2rem;
}

.classe-buttom {
  max-height: 40px;
  margin-top: 14px;
}

.pesquisa-usuario-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
</style>


